import { Box } from '@dhl-ui/components'
import { useGetStyling } from './use-get-styling'
import { type PageContentProps } from './types'

/**
 * A container where we set the content distance based on the theme correctly.
 *
 * @example <Page><Page.Content isFullView>your application content</Page.Content></Page>
 */
export const Content = ({
  children,
  isMaximizedCentered,
  isFullView,
  hasMaxSize,
  'data-testid': testId,
  hasBottomMenu,
  sx,
}: PageContentProps) => {
  const style = useGetStyling({ sx, isMaximizedCentered, isFullView, hasMaxSize, hasBottomMenu })

  return (
    <Box sx={style} data-testid={testId || 'innerContent'}>
      {children}
    </Box>
  )
}
